import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';
import { LocalService} from '../services/local.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router, public route: Location, private localService: LocalService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    var is_superuser = (this.localService.getJsonValue('is_superuser') ? true : false);
    if (is_superuser) {
      return true;
    } else {
      this.router.navigate(['/landing']);
      return false;
    }
  }
}
